import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productLabel: {
    description: 'Label for product input in Set Product on Order automation rule',
    defaultMessage: 'Product',
    id: 'jka07b',
  },
  quantityLabel: {
    description: 'Label for quantity input in Set Product on Order automation rule',
    defaultMessage: 'Quantity',
    id: 'MIL4BY',
  },
  productSearch: {
    description: 'Aria label for product search input in Set Product on Order automation rule',
    defaultMessage: 'Search for a product',
    id: 'yjs7qM',
  },
});
